import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide, useSwiper } from "swiper/react";
import "swiper/swiper-bundle.css"; // Import Swiper styles
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import { apiCall, mediaUrl } from "../util";
import axios from "axios";
import {
  feedbacks,
  gcarehome,
  gokulam_banner_04,
  gokulam_logo_icon,
  hero_booking_img,
  our_facilities,
  telemedicine,
} from "../Image";
import anime from "animejs";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { useQuery } from "@tanstack/react-query";

const fetchBanner = async () => {
  const response = await axios.get(apiCall + "banner_image/getall");
  return response.data.sort((a, b) => {
    if (a.priority === 0) return 1;
    if (b.priority === 0) return -1;
    return a.priority - b.priority;
  });
};

const HeroBannerSlider = () => {
  const [swiperHeight, setSwiperHeight] = useState("525px");
  const [doctor, setDoctor] = useState([]);
  const [department, setDepartment] = useState([]);
  const [selectedDepartment, setSelectedDepartment] = useState("");
  const [selectedDoctor, setSelectedDoctor] = useState("");
  // const [bannerData, setBannerData] = useState([]);
  const swiper = useSwiper();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const doctorResponse = await axios.get(apiCall + "doctor/getall");
        setDoctor(doctorResponse.data);

        const departmentResponse = await axios.get(
          apiCall + "department/getall"
        );
        setDepartment(departmentResponse.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

  const handleDepartmentChange = (e) => {
    const departmentId = parseInt(e.target.value);
    setSelectedDepartment(departmentId);
    setSelectedDoctor(""); // Reset doctor selection when department changes
  };

  const handleDoctorChange = (e) => {
    const doctorId = parseInt(e.target.value);
    setSelectedDoctor(doctorId);

    const selectedDoc = doctor.find((doc) => doc.id === doctorId);
    if (selectedDoc) {
      setSelectedDepartment(selectedDoc.department_id);
    }
  };

  const filteredDoctors = selectedDepartment
    ? doctor.filter((doc) => doc.department_id === selectedDepartment)
    : doctor;

  const services = [
    {
      imgSrc: telemedicine,
      title: "Telemedicine",
    },
    {
      imgSrc: gcarehome,
      title: "Second Opinion",
    },
    {
      imgSrc: our_facilities,
      title: "Privilege Card",
    },
    {
      imgSrc: feedbacks,
      title: "Feedbacks",
    },
  ];

  const { data: bannerData } = useQuery({
    queryKey: ["bannerData"],
    queryFn: fetchBanner,
    staleTime: 60 * 60 * 1000,
    cacheTime: 24 * 60 * 60 * 1000,
    refetchInterval: 60 * 60 * 1000,
  });
  useEffect(() => {
    if (swiper) {
      swiper.slideTo(0, 0); // Move to the first slide instantly
    }
  }, [bannerData]);

  const cardsRef = useRef(null);

  useEffect(() => {
    // Card Animation - Staggered Fade In
    anime({
      targets: cardsRef.current.children,
      opacity: [0, 1],
      translateY: [50, 0],
      delay: anime.stagger(200), // Delays each card animation
      duration: 1000,
      easing: "easeOutQuad",
    });

    // Floating Logo Animation
    anime({
      targets: ".animated-logo",
      translateY: [0, 10],
      duration: 2000,
      easing: "easeInOutSine",
      direction: "alternate",
      loop: true,
    });

    // Rotating Logo Animation
    anime({
      targets: ".animated-logo-2",
      rotate: "1turn",
      duration: 5000,
      easing: "linear",
      loop: true,
    });
  }, []);

  // useEffect(() => {
  //   const handleResize = () => {
  //     if (window.innerWidth <= 600) {
  //       setSwiperHeight("550px"); // Mobile height
  //     } else if (window.innerWidth <= 992) {
  //       setSwiperHeight("550px"); // Tablet height
  //     } else {
  //       setSwiperHeight("600px"); // Desktop height
  //     }
  //   };

  //   handleResize(); // Set initial height
  //   window.addEventListener("resize", handleResize);

  //   return () => window.removeEventListener("resize", handleResize);
  // }, []);

  return (
    <>
      <section className="section-dark p-0  top-space-margin hero-banner-sldier">
        <style>
          {`
          .swiper-pagination {
              position: absolute;
              bottom: 30px;
              display: flex;
              justify-content: center;
              align-items: center;
              width: 100%;
              gap: 17px;
              z-index: 10;
            }

          .swiper-pagination-bullet {
            width: 10px;
            height: 10px;
            background-color: rgba(255, 255, 255);
            border-radius: 50%;
            transition: all 0.3s ease;
            transform: scale(1);
            position: relative;
            padding:"100px"
          }

          .swiper-pagination-bullet-active {
            width: 10px;
            height: 10px;
            background-color: rgba(255, 255, 255);
            border-radius: 50%;
            opacity: 1;
            transform: scale(1);
          }

          .swiper-pagination-bullet-active::before {
            content: "";
            position: absolute;
            top: -10px;
            left: -10px;
            width: 30px;
            height: 30px;
            border: 2px solid rgba(255, 255, 255, 0.3);
            border-radius: 50%;
            z-index: -1;
          }

          .swiper-pagination-bullet:hover::before {
            content: "";
            position: absolute;
            top: -10px;
            left: -10px;
            width: 30px;
            height: 30px;
            border: 2px solid rgba(255, 255, 255, 0.3);
            border-radius: 50%;
            z-index: -1;
          }
        `}
        </style>

        {bannerData ? (
          <>
            <Swiper
              // style={{ height: swiperHeight, marginTop: "-15px" }}
              slidesPerView={1}
              loop={true}
              parallax={true}
              speed={1000}
              initialSlide={0}
              pagination={{
                clickable: true,
              }}
              navigation={true}
              autoplay={{
                delay: 4000,
                disableOnInteraction: false,
              }}
              keyboard={{
                enabled: true,
                onlyInViewport: true,
              }}
              modules={[Pagination, Navigation, Autoplay]}
            >
              {bannerData.map((data, index) => (
                <SwiperSlide key={index} className="overflow-hidden">
                  <picture>
                    {/* Mobile: max-width 600px */}
                    <source
                      media="(max-width: 768px)"
                      srcSet={`${mediaUrl}/${data.mobileimage}`}
                    />

                    {/* Tablet: 601px to 1024px */}
                    <source
                      media="(min-width: 769px) and (max-width: 1024px)"
                      srcSet={`${mediaUrl}/${data.mobileimage}`}
                    />

                    {/* Desktop: min-width 1025px */}
                    <source
                      media="(min-width: 1025px)"
                      srcSet={`${mediaUrl}/${data.image}`}
                    />

                    {/* Fallback image */}
                    <img
                      className="w-100 object-cover"
                      src={`${mediaUrl}/${data.image}`}
                      alt="slider"
                    />
                  </picture>
                </SwiperSlide>
              ))}
            </Swiper>
            <div className="container-fluid position-relative p-0">
              <div className="online_appointment_section bg-sg-light-gradient">
                <div className="row flex-column gy-2">
                  <div className="col-12">
                    <div className="d-flex gap-2 mb-15px">
                      <img
                        src={gokulam_logo_icon}
                        alt="gokulam logo icon"
                        width="40px"
                      />
                      <h5 className="text-dark fs-20 fw-bold m-0 lh-22">
                        Book Your <br />
                        <span className="text-base-color">
                          Appointment Online
                        </span>
                      </h5>
                    </div>
                  </div>
                  <div className="col-9">
                    <div className="select">
                      <select
                        className="form-control"
                        name="department"
                        aria-label="Choose Department"
                        value={selectedDepartment}
                        onChange={handleDepartmentChange}
                      >
                        <option value="">Choose Department</option>
                        {department.map((dept) => (
                          <option key={dept.id} value={dept.id}>
                            {dept.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  <div className="col-9 mt-3">
                    <div className="select">
                      <select
                        className="form-control"
                        name="doctor"
                        aria-label="Choose Doctor"
                        value={selectedDoctor}
                        onChange={handleDoctorChange}
                      >
                        <option value="">Choose Doctor</option>
                        {filteredDoctors.map((doc) => (
                          <option key={doc.id} value={doc.id}>
                            {doc.name} (
                            {department.find((d) => d.id === doc.department_id)
                              ?.name || "Unknown Department"}
                            )
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="col-9 mt-15px">
                    <button
                      onClick={() => {
                        // Handle the appointment booking logic here
                      }}
                      className="btn btn-md btn-gradient-sg-header d-table d-lg-inline-block md-mx-auto me-20px sg-border-styled fw-600 pt-10px pb-10px w-100"
                    >
                      <i className="fa-solid fa-stethoscope"></i>
                      Book an Appointment
                    </button>
                  </div>
                </div>
                <div className="online_appointment_img">
                  <img src={hero_booking_img} alt="Booking" />
                </div>
              </div>
            </div>
          </>
        ) : (
          <Skeleton width="100%" height={600} />
        )}
      </section>

      <section className="py-4 sg-li position-relative bg-very-light-gray overflow-hidden">
        {/* Animated Logos */}
        <img
          src={gokulam_logo_icon}
          alt="gokulam logo"
          className="animated-logo float"
        />
        <img
          src={gokulam_logo_icon}
          alt="gokulam logo"
          className="animated-logo-2 rotate"
        />

        {/* Content */}
        <div className="container z-3 position-relative">
          <div className="row justify-content-center gy-4" ref={cardsRef}>
            {services.map((service, index) => (
              <div key={index} className="col-6 col-sm-6 col-md-6 col-lg-3">
                <Link
                  to="/services"
                  className="h-100 text-center bg-white box-shadow-large border-radius-20px ps-10px pe-10px pt-15px pb-15px d-block"
                >
                  <div className="mb-15px">
                    <img
                      src={service.imgSrc}
                      className="md-h-50px h-60px object-fit-cover"
                      alt={service.title}
                    />
                  </div>
                  <h5 className="lg-fs-16 fs-18 fw-500 text-dark-gray m-0 lh-sm">
                    {service.title}
                  </h5>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default HeroBannerSlider;
